<template>
    <div style="position: relative;">
        <!-- FOR SMARTPHONE ONLY -->
        <template v-if="windowWidth < 600">
            <div v-if="navigation.menu.id">
                <vs-icon
                    class="icon-back-mobile mr-2 text-danger cursor-pointer"
                    icon-pack="material-icons"
                    icon="reply_all"
                    @click="changeBread('')" />
                    <span class="lbl-back-mobile-hint" v-if="navigation.menu.id && !navigation.pType.id"> MENUS </span>
                    <span class="lbl-back-mobile-hint" v-if="navigation.pType.id"> CATEGORIAS </span>
            </div>
        </template>

        <!-- FOR LARGE WINDOW SIZE ONLY -->
        <template v-else> 
            <vs-icon
                class="icon-back mr-2 text-danger cursor-pointer"
                icon-pack="material-icons"
                icon="reply_all"
                @click="changeBread(0)" v-if="navigation.menu.id" />
            <div class="bread-crumb">
                <span 
                    :class="navigation.pType.id ? 'text-danger cursor-pointer underline' : ''"
                    class="title" 
                    @click="changeBread(1)" 
                    v-if="navigation.menu.id">{{ (navigation.menu.description || '').toUpperCase() }}</span>
                <vs-icon
                    class="ml-2 mr-2"
                    icon-pack="material-icons"
                    icon="double_arrow" 
                    v-show="navigation.pType.id"/>  
                <span class="title" v-if="navigation.pType.id">{{ (navigation.pType.description || '').toUpperCase() }}</span>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props : {
            navigation : {
                type : Object,
                required : true
            }
        },

        computed : {
            windowWidth () {
                return this.$store.state.windowWidth
            },
        },

        methods : {
            changeBread(to) {
                this.$emit('change', to)
            }
        }
    }
</script>

<style scoped>
    .bread-crumb {
        position: inherit;
        /* left: 60px; */
        margin-left : 60px;
    }

    .title {
        font-size: 18px;
    }

    .icon-back {
        position : absolute;
        top: -6px;
        font-size: 40px;
    }

    .lbl-back-mobile-hint {
        position: relative;
        font-size: 18px;
        top: -12px
    }

    .icon-back-mobile {
        font-size: 40px;
    }

    .icon-bread {
        position : relative;
        top: 5px;
        font-size: 22px; 
    }
</style>